module.exports = __webpack_public_path__ + "static/img/season-dia-bubble-alert.721d3eb.png";